<template>
  <div class="badge-container">
    <span :style="style">{{ text }}</span>
  </div>
</template>


<script>
export default {
  name: 'Badge',
  props: {
    text: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: '16px',
    },
    bgColor: {
      type: String,
      default: '#36a8ff',
    },
  },
  data() {
    return {
      style: {},
    }
  },
  created() {
    this.style = {
      fontSize: this.size,
      backgroundColor: this.bgColor,
    }
  },
}
</script>


<style lang="scss" scoped>
.badge-container {
  width: 100px;
  height: 100px;
  position: absolute;
  /*background: green;*/
  top: -50px;
  right: -50px;
  transform: rotate(45deg);
  & > span {
    position: absolute;
    bottom: 0;
    display: block;
    font-size: 16px;
    color: #fff;
    background: #36a8ff;
    width: 100px;
    text-align: center;
  }
}
</style>
